import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * Internal dependencies
 */
import Dropdown from './Dropdown';
const today = new Date();
const dd = String(today.getDate()).padStart(2, '0');
const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
const yyyy = today.getFullYear();
const dateOptions = [
    { value: 'today', label: 'Today' },
    { value: 'this-weekend', label: 'This weekend' },
    { value: 'this-week', label: 'This week' },
    { value: 'next-week', label: 'Next week' },
    { value: 'next-weekend', label: 'Next weekend' },
    { value: 'next-month', label: 'Next month' },
];
const DateDropdown = ({ placeholder = 'When', onChange, name = 'eventDate' }) => {
    return (_jsx(_Fragment, { children: _jsx(Dropdown, { options: dateOptions, name: name, placeholder: placeholder, onChange: onChange }) }));
};
export default DateDropdown;
